import Chevron from '../../navigationMenu/components/chevron';
import Dropdown from '../../../../ui/dropdownMenu/dropdownMenu';
import { isSiteCanadian } from '../../../../../utils/helpers';
import { IUser } from '../../../../../utils/interfaces/user';
import { useLocalization } from 'src/utils/useLocalization';
import { USER_ACTIONS } from '../../../../../utils/enums/user-store-actions.enum';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../assets/dealers.scss';

interface IDealerMenuList {
    name: string;
    path?: string;
    handler?: any;
}

const DistrictList: React.FC = () => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState<boolean>(false);
    const [setRotate, setRotateState] = useState<string>(
        'accordion__icon rotate',
    );
    const { districs, selectedDistrics } = useSelector((state: IUser) => {
        return state;
    });
    const [selected, setSelected] = useState<string>(selectedDistrics || '');
    const [list, setList] = useState<Array<IDealerMenuList>>([]);
    const { labelText } = useLocalization();
    useEffect(() => {
        const init: any[] = [];
        let aux: any[] = [];
        if (districs?.length) {
            aux = districs.length
                ? districs?.map((ele: { districtId: string }) => {
                      return {
                          name: `${labelText.LABEL_TEXT_DASH_DISTRICT} ${ele.districtId}`,
                          path: '#',
                          handler: () => {
                              setSelected(`${ele.districtId}`);
                              dispatch({
                                  type: USER_ACTIONS.SET_DEFAULT_DISTRICT,
                                  payload: ele.districtId,
                              });
                          },
                      } as IDealerMenuList;
                  })
                : [];
        }
        setList(init.concat(aux));
    }, [districs]);

    return (
        <div
            className={'district-list dealer-list u-mr-large'}
            onClick={() => {
                setOpen(!open);
                setRotateState(
                    open
                        ? 'accordion__icon rotate'
                        : 'accordion__icon rotate-270',
                );
            }}
        >
            <i
                className={'c-icon-list__icon c-icon c-icon--[find-a-dealer]'}
                aria-hidden='true'
                role='img'
            />
            {!!selected
                ? `${labelText.LABEL_TEXT_DASH_DISTRICT} ${selected}`
                : `${labelText.LABEL_TEXT_DASH_SELECT} ${labelText.LABEL_TEXT_DASH_DISTRICT}`}
            <span className={'u-mt-xlarge u-ml-xsmall'}>
                <Chevron className={`${setRotate}`} width={10} fill={'#777'} />
            </span>
            <Dropdown
                dropdown={open}
                submenus={list}
                handlerChange={(value: boolean) => {
                    setOpen(value);
                    setRotateState(
                        !value
                            ? 'accordion__icon rotate'
                            : 'accordion__icon rotate-270',
                    );
                }}
                handlerItemChange={setSelected}
                showSelected={true}
                defaultSelected={
                    !!selected
                        ? selected
                        : `${labelText.LABEL_TEXT_DASH_SELECT} ${labelText.LABEL_TEXT_DASH_DISTRICT}`
                }
                showSelectedIcon={true}
                right={!isSiteCanadian() ? '75' : '145'}
                isDealership={false}
            />
        </div>
    );
};

export default DistrictList;
